import React from "react";
import Logo from "../components/Logo";
import BackButton from "../components/BackButton";
import { Button } from "../components/ui/button";
import { Bell, Info } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { WaitlistDialog } from "@/components/WaitlistDialog";

const ArrivingSoon = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  // Check if user came from eateries page
  const fromEateriesPage = location.state && location.state.fromEateriesPage;

  return (
    <div className="min-h-[100dvh] flex flex-col items-center p-6">
      <BackButton />
      <div className="w-full max-w-4xl mx-auto">
        <Logo />

        <div className="mt-12 space-y-8 text-center">
          {/* Heading */}
          <h1
            className="text-5xl font-bold bg-gradient-to-r from-black to-gray-700 bg-clip-text text-transparent animate-fade-up opacity-0"
            style={{ animationDelay: "0.2s" }}
          >
            Boost Cards Arriving Soon!
          </h1>

          <h2
            className="text-2xl font-semibold text-black animate-fade-up opacity-0"
            style={{ animationDelay: "0.3s" }}
          >
            A batch of Boost Cards are out for delivery for this location,
            and should be arriving soon
          </h2>

          {/* “What are Boost Cards?” button at the top (if not from Eateries page) */}
          {!fromEateriesPage && (
            <div
              className="animate-fade-up opacity-0"
              style={{ animationDelay: "0.4s" }}
            >
              <Button
                variant="outline"
                onClick={() => navigate("/")}
                className="text-gray-700 hover:text-gray-900 space-x-2"
              >
                <Info className="w-5 h-5" />
                <span>What are Boost Cards?</span>
              </Button>
            </div>
          )}

          {/* Green notification box */}
          <div
            className="relative py-6 px-8 bg-[#F2FCE2] rounded-lg border-2 border-green-300 shadow-lg animate-scale-in opacity-0"
            style={{ animationDelay: "0.5s" }}
          >
            <p className="text-lg text-gray-800">
              We can notify you once{" "}
              <span className="font-bold">Boost Cards</span> arrive and are
              ready for purchase
            </p>
          </div>

          {/* “Notify Me” button below the box */}
          <div
            className="animate-fade-up opacity-0"
            style={{ animationDelay: "0.6s" }}
          >
            <Button
              onClick={() => setIsDialogOpen(true)}
              className="bg-eatsboost-orange hover:bg-eatsboost-orange/90 text-white space-x-2"
            >
              <span>Notify Me</span>
              <Bell className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>

      {/* Dialog for Waitlist */}
      <WaitlistDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        tableName="arriving_soon"
      />
    </div>
  );
};

export default ArrivingSoon;
